import { useDispatch } from "react-redux";
import {
  formatConfidence,
  formatLift,
  formatSupport,
  getCategoryNames,
  getStrength,
  getStrengthColor,
  getStrengthThumb,
} from "../../../../common/common";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import ProductBundles from "../ProductBundles/productBundles";
import { setAntecedentInfo } from "../../../../../store";
import CustomerPopupWithOrder from "../customerPopupwithOrder";
import axios from 'axios';
import { toast } from "react-toastify";
import FavoritePage from "../../../favorite/favorite";
import SkuReport from "./skuReport";

const AnalysisResultData = ({
  analysisDetailsHistory,
  isLoading,
  switchTab,
  selectDesign,
  currentPage,
  displayAnalysisResult,
  setCurrentPage,
  currentAnalysisData,
  productsBundles,
  order_details_id,
  isSingleOrderExclude,
  favoriteSkuResponseList,
  supportFilter,
  sortBy,
  searchQueryForItemsets,
  setCountItemSet,
  selectedCombo,
  isDefault
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const itemsPerPage = 10;

  const [isModalOpen, setModalOpen] = useState(false);
  const [sku, setSku] = useState([]);
  const [isBoth, setIsBoth] = useState({
    antecedent: false,
    consequent: false,
    all: false,
  });
  const [productList, setProductList] = useState([]);
  const [analysisResultFavoriteList, setAnalysisResultFavoriteList] = useState({});
  const [analysisResultFavoriteSkuList, setAnalysisResultFavoriteSkuList] = useState({});


  const handleView = (asku, csku, allsku, isSignle) => {
    setModalOpen(true);
    setSku({
      antecedentSKU: asku,
      consequentSKU: csku,
      allSku: allsku,
    });
  };


  const markAsFavorite = async (analysis_result_id, isFavorite=true) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_END_POINT}/data-analysis/analysis-result-favorite`,
        null, // no body for PUT query param-based request
        {
          params: {
            analysis_result_id,
            isFavorite,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      
      toast.success("Favorite updated")
      return isFavorite;
    //   console.log("Favorite updated:", response.data);
    //   return response.data;
    } catch (error) {
      if (error.response.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      toast.error(error.response?.data || error.message)
      return isFavorite; // fallback: unchanged
    //   console.error("Error updating favorite:", error.response?.data || error.message);
    //   throw error;
    }
  };


  const handleToggleFavorite = async (id, isFavorite=false) => {
    const newStatus = await markAsFavorite(id, !isFavorite);
    setAnalysisResultFavoriteList((prev)=>{
        return {
            ...prev,
            [id]: newStatus
        }
    });
  };

  const markAsSKUFavorite = async (data) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_END_POINT}/data-analysis/analysis-sku-favorite`,
        data, // no body for PUT query param-based request
        {
          
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      
      toast.success("Favorite updated")
      return data.isFavorite;
    //   console.log("Favorite updated:", response.data);
    //   return response.data;
    } catch (error) {
      if (error.response.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      toast.error(error.response?.data || error.message)
      return data.isFavorite; // fallback: unchanged
    //   console.error("Error updating favorite:", error.response?.data || error.message);
    //   throw error;
    }
  };

  const handleToggleSKUFavorite = async (data, isFavorite=false,test,test2) => {
    let skuData = {
        image: data.image,
        product_title: data.product_title,
        order_details_id: order_details_id,
        analysis_details_id: currentAnalysisData._id,
        sku: data.sku,
        isFavorite: !isFavorite
    }
    const newStatus = await markAsSKUFavorite(skuData);
    setAnalysisResultFavoriteSkuList((prev)=>{
        return {
            ...prev,
            [data.sku]: newStatus
        }
    });
  };
  

  const paginatedOrders = displayAnalysisResult.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(displayAnalysisResult.length / itemsPerPage);
  const getPaginationRange = () => {
    const totalVisible = 5;
    const range = [];
    const showLeftEllipsis = currentPage > 3;
    const showRightEllipsis = currentPage < totalPages - 2;
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, currentPage + 2);
    if (currentPage <= 3) {
      end = Math.min(5, totalPages);
    } else if (currentPage >= totalPages - 2) {
      start = Math.max(totalPages - 4, 1);
    }

    for (let i = start; i <= end; i++) {
      range.push(i);
    }

    return { range, showLeftEllipsis, showRightEllipsis };
  };
  const {
    range: paginationRange,
    showLeftEllipsis,
    showRightEllipsis,
  } = getPaginationRange();

  return (
    <>
      <div className=" config-cards">
        <div class=" gap-[20px] flex flex-col md:flex-row  cstm-config-card">
          <div class="w-full flex flex-col">
            <div
              id="tab-content"
              class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300  pys-5 pxss-5 config-cards"
            >
              {/* {analysisDetailsHistory.length === 0 && (
                <div className="flex items-center justify-center h-64 text-gray-500 text-lg">
                  No Record Found
                </div>
              )} */}

              {true && (
                <>
                  <div
                    id="config-tab-content"
                    class={`fade-in ${switchTab === 1 ? "" : "hidden"}`}
                  >
                    {isLoading && (
                      <div className="flex items-center justify-center h-40 w-full">
                        <div className="flex items-center space-x-2 text-indigo-600 text-sm font-medium">
                          <svg
                            className="animate-spin h-5 w-5 text-indigo-600"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8v8H4z"
                            ></path>
                          </svg>
                          <span>Please wait...</span>
                        </div>
                      </div>
                    )}
                    {!isLoading && (
                      <div id="resultsContainer">
                        <div class="mb-0 cstm_ResultsTest-radius rounded-none ">
                          <div className="flex flex-wrap items-start">
                            <div class="w-full">
                              {selectDesign === 1 &&
                                paginatedOrders.length > 0 &&
                                paginatedOrders.map((result, index) => {
                                    let isFavorite = analysisResultFavoriteList[result._id] == undefined ?
                                                result?.isFavorite ? 
                                                result?.isFavorite 
                                                : false
                                                 : analysisResultFavoriteList[result._id]
                                  return (
                                    <section class=" rounded-lg shadow-sm ">
                                      <div class="section-data-starts  mb-10 bg-white">
                                        <div
                                          class={`h-12 ${
                                            getStrength(result) === "Strong"
                                              ? "bg-powder-lavender-mint"
                                              : "bg-soft-to-deep-red"
                                          }   rounded-t-lg flex items-center justify-between px-6`}
                                        >
                                          <div className="flex items-center gap-3">
                                            {/* Strength Badge */}
                                            <span
                                                className={`px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1
                                                ${
                                                    getStrength(result) === "Strong"
                                                    ? "bg-[#dcfce7]"
                                                    : "bg-[#fee2e2]"
                                                }
                                                ${getStrengthColor(result)}
                                                `}
                                            >
                                                <i className={getStrengthThumb(result)}></i>
                                                {getStrength(result)}
                                            </span>
                                            {/* Favorite Icon */}
                                            <span 
                                            className={`cursor-pointer text-red-500`}
                                            onClick={()=>{handleToggleFavorite(result._id,isFavorite)}}
                                            
                                            >
                                                <i className={isFavorite ? "fas fa-heart" : "far fa-heart"}></i>
                                            </span>
                                            </div>
                                         
                                          <p class="text-sm text-black-700">
                                          Among shoppers who bought{" "}
                                            <b>
                                              {result.antecedentSkus.join(",")}
                                            </b>{" "}
                                             Out of those&nbsp;
                                            {formatConfidence(
                                              result.confidence
                                            )}
                                            %  also bought{" "}
                                            <span class="font-semibold">
                                              {result.consequentSkus.join("+")}{" "}
                                              
                                            </span>
                                          </p>
                                        </div>
                                        <div class="text-center text-sm text-black-700 px-6 pt-4">
                                          <span
                                            class="inline-block mx-2 cursor-pointer"
                                            onClick={() => {
                                              handleView(
                                                result?.antecedentSkus,
                                                result?.consequentSkus,
                                                result?.allSkus,
                                                true
                                              );
                                              setIsBoth({
                                                antecedent: false,
                                                consequent: false,
                                                all: true,
                                              });
                                              setProductList(result);
                                            }}
                                          >
                                            👥{" "}
                                            <span class="font-medium text-[#5E7BAA]">
                                              <u className="cursor-pointer">
                                                {result.totalPurchasedTogether}
                                              </u>
                                            </span>{" "}
                                            joint orders
                                          </span>
                                          <span
                                            class="inline-block mx-2 cursor-pointer"
                                            onClick={() => {
                                              handleView(
                                                result?.antecedentSkus,
                                                result?.consequentSkus,
                                                result?.allSkus,
                                                true
                                              );
                                              setIsBoth({
                                                antecedent: false,
                                                consequent: false,
                                                all: true,
                                              });
                                              setProductList(result);
                                            }}
                                          >
                                            🛒{" "}
                                            <span class="font-medium text-[#5E7BAA] cursor-pointer">
                                              <u className="">
                                                {
                                                  result?.together_customer_count
                                                }
                                              </u>
                                            </span>{" "}
                                            unique customers
                                          </span>
                                          <span class="inline-block mx-2">
                                            <i class="fas fa-chart-pie text-xs mr-1 text-[#5E7BAA]"></i>{" "}
                                            Support{" "}
                                            <span class="font-medium text-[#5E7BAA]">
                                              {formatSupport(result.support)}%
                                            </span>
                                          </span>
                                          <span class="inline-block mx-2">
                                            <i class="fas fa-bullseye  text-xs mr-1 text-[#5E7BAA]"></i>{" "}
                                            Confidence{" "}
                                            <span class="font-medium text-[#5E7BAA]">
                                              {formatConfidence(
                                                result.confidence
                                              )}
                                              %
                                            </span>
                                          </span>
                                          <span class="inline-block mx-2">
                                            <i class="fas fa-level-up-alt  text-xs mr-1 text-[#5E7BAA]"></i>{" "}
                                            Lift{" "}
                                            <span class="font-medium text-[#5E7BAA]">
                                              {formatLift(result.lift)}
                                            </span>
                                          </span>
                                        </div>
                                        <div class="border-t border-[#E5EAF1] my-4"></div>

                                        <div class="relative md:grid md:grid-cols-[1fr_auto_1fr] gap-8 px-6 py-4">
                                          <div class="flex flex-col justify-between">
                                            <div class="block w-full">
                                              <h3 class="text-xs uppercase text-black-600 font-semibold mb-3">
                                                IF Customer Buys
                                              </h3>

                                              {result.antecedents.map(
                                                (data) => {
                                                    let isFavorite = analysisResultFavoriteSkuList[data.sku] == undefined ?
                                                     favoriteSkuResponseList.some(item => item.sku === data.sku) ? 
                                                     favoriteSkuResponseList.some(item => item.sku === data.sku) 
                                                     : false
                                                      : analysisResultFavoriteSkuList[data.sku]
                                                  return (
                                                    <div class="flex gap-3 mb-4">
                                                      <div class="w-16 h-16 rounded-md bg-[#EDF1F5] flex items-center justify-center text-black-400">
                                                        <img
                                                          src={
                                                            data.image
                                                              ? data.image
                                                              : "noimage.jpg"
                                                          }
                                                          class="h-12 w-12"
                                                        />
                                                      </div>
                                                      <div>
                                                        <p class="font-medium leading-snug text-black-800">
                                                          {data.product_title}
                                                        </p>
                                                        <div className="flex items-center justify-left gap-2">
                                                            <p
                                                                className="text-xs text-black-500 cursor-pointer underline"
                                                                onClick={() => {
                                                                dispatch(setAntecedentInfo(data));
                                                                navigate(`/product`, {
                                                                    state: {
                                                                    order_details_id: order_details_id,
                                                                    isSingleOrderExclude: isSingleOrderExclude,
                                                                    },
                                                                });
                                                                }}
                                                            >
                                                                {[
                                                                data.sku,
                                                                data.color,
                                                                data.selling_price && `$${data.selling_price}`,
                                                                ]
                                                                .filter(Boolean)
                                                                .join(" | ")}
                                                            </p>
                                                            

                                                            <span 
                                                            className={`cursor-pointer text-red-500`}
                                                            onClick={()=>{handleToggleSKUFavorite(data,isFavorite)}}
                                                            >
                                                                <i className={isFavorite ? "fas fa-heart" : "far fa-heart"}></i>
                                                            </span>
                                                            
                                                        </div>
                                                        <div className="flex items-center justify-left gap-2">
                                                          <p
                                                            className="text-xs text-black-500 "
                                                          >
                                                            {getCategoryNames(data.category,",")}
                                                          </p>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              )}
                                            </div>

                                            <div class="bg-[#F4F6FA] p-3 rounded-md mt-4">
                                              <div class="flex justify-between text-sm mb-1">
                                                <span
                                                  class="text-black-600"
                                                  data-tooltip="Number of orders containing only these items"
                                                >
                                                  Orders with IF Items:
                                                </span>
                                                <span class="font-medium text-[#5E7BAA]">
                                                  <u
                                                    className="cursor-pointer"
                                                    onClick={() => {
                                                      handleView(
                                                        result?.antecedentSkus,
                                                        result?.consequentSkus,
                                                        result?.allSkus,
                                                        true
                                                      );
                                                      setIsBoth({
                                                        antecedent: true,
                                                        consequent: false,
                                                        all: false,
                                                      });
                                                      setProductList(result);
                                                    }}
                                                  >
                                                    {
                                                      result.antecedentPurchasedTogether
                                                    }{" "}
                                                    orders
                                                  </u>
                                                  &nbsp; |&nbsp;{" "}
                                                  <u
                                                    className="cursor-pointer"
                                                    onClick={() => {
                                                      handleView(
                                                        result?.antecedentSkus,
                                                        result?.consequentSkus,
                                                        result?.allSkus,
                                                        true
                                                      );
                                                      setIsBoth({
                                                        antecedent: true,
                                                        consequent: false,
                                                        all: false,
                                                      });
                                                      setProductList(result);
                                                    }}
                                                  >
                                                    {
                                                      result?.antecedent_customer_count
                                                    }{" "}
                                                    customers
                                                  </u>
                                                </span>
                                              </div>
                                              <div class="flex justify-between text-sm mb-1">
                                                <span
                                                  class="text-black-600"
                                                  data-tooltip="Frequency of the itemset in all transactions"
                                                >
                                                  Support:
                                                </span>
                                                <span class="font-medium text-[#5E7BAA]">
                                                  {formatSupport(
                                                    result.antecedent_support
                                                  )}
                                                  %
                                                </span>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="hidden md:flex items-center justify-center">
                                            <div class="w-auto my-6 self-center">
                                              <div class="product-combo w-16 mx-auto"></div>
                                            </div>
                                          </div>

                                          <div class="flex flex-col justify-between">
                                            <div class="block w-full">
                                              <h3 class="text-xs uppercase text-black-600 font-semibold mb-3">
                                                THEN Customer Also Buys
                                              </h3>

                                              {result.consequent.map((data) => {
                                                let isFavorite = analysisResultFavoriteSkuList[data.sku] == undefined ?
                                                favoriteSkuResponseList.some(item => item.sku === data.sku) ? 
                                                favoriteSkuResponseList.some(item => item.sku === data.sku) 
                                                : false
                                                 : analysisResultFavoriteSkuList[data.sku]
                                                return (
                                                  <div class="flex gap-3 mb-4">
                                                    <div class="w-16 h-16 rounded-md bg-[#EDF1F5] flex items-center justify-center text-black-400">
                                                      <img
                                                        src={
                                                          data.image
                                                            ? data.image
                                                            : "noimage.jpg"
                                                        }
                                                        class="h-12 w-12"
                                                      />
                                                    </div>
                                                    <div>
                                                      <p class="font-medium leading-snug text-black-800">
                                                        {data.product_title}
                                                      </p>
                                                      <div className="flex items-center justify-left gap-2">
                                                            <p
                                                                className="text-xs text-black-500 cursor-pointer underline"
                                                                onClick={() => {
                                                                dispatch(setAntecedentInfo(data));
                                                                navigate(`/product`, {
                                                                    state: {
                                                                    order_details_id: order_details_id,
                                                                    isSingleOrderExclude: isSingleOrderExclude,
                                                                    },
                                                                });
                                                                }}
                                                            >
                                                                {[
                                                                data.sku,
                                                                data.color,
                                                                data.selling_price && `$${data.selling_price}`,
                                                                ]
                                                                .filter(Boolean)
                                                                .join(" | ")}
                                                            </p>

                                                            <span 
                                                            className={`cursor-pointer text-red-500`}
                                                            onClick={()=>{handleToggleSKUFavorite(data,isFavorite)}}
                                                            >
                                                                <i className={isFavorite ? "fas fa-heart" : "far fa-heart"}></i>
                                                            </span>
                                                        </div>
                                                        <div className="flex items-center justify-left gap-2">
                                                          <p
                                                            className="text-xs text-black-500 "
                                                          >
                                                            {getCategoryNames(data.category,",")}
                                                          </p>
                                                        </div>
                                                    </div>
                                                  </div>
                                                );
                                              })}
                                            </div>

                                            <div class="bg-[#F4F6FA] p-3 rounded-md mt-4">
                                              <div class="flex justify-between text-sm mb-1">
                                                <span
                                                  class="text-black-600"
                                                  data-tooltip="Number of orders containing only these items"
                                                >
                                                  Orders with THEN Items:
                                                </span>
                                                <span class="font-medium text-[#5E7BAA]">
                                                  <u
                                                    className="cursor-pointer"
                                                    onClick={() => {
                                                      handleView(
                                                        result?.antecedentSkus,
                                                        result?.consequentSkus,
                                                        result?.allSkus,
                                                        true
                                                      );
                                                      setIsBoth({
                                                        antecedent: false,
                                                        consequent: true,
                                                        all: false,
                                                      });
                                                      setProductList(result);
                                                    }}
                                                  >
                                                    {
                                                      result.consequnetPurchasedTogether
                                                    }{" "}
                                                    orders
                                                  </u>
                                                  &nbsp; |&nbsp;{" "}
                                                  <u
                                                    className="cursor-pointer"
                                                    onClick={() => {
                                                      handleView(
                                                        result?.antecedentSkus,
                                                        result?.consequentSkus,
                                                        result?.allSkus,
                                                        true
                                                      );
                                                      setIsBoth({
                                                        antecedent: false,
                                                        consequent: true,
                                                        all: false,
                                                      });
                                                      setProductList(result);
                                                    }}
                                                  >
                                                    {
                                                      result?.consequent_customer_count
                                                    }{" "}
                                                    customers
                                                  </u>
                                                </span>
                                              </div>
                                              <div class="flex justify-between text-sm mb-1">
                                                <span
                                                  class="text-black-600"
                                                  data-tooltip="Frequency of the itemset in all transactions"
                                                >
                                                  Support:
                                                </span>
                                                <span class="font-medium text-[#5E7BAA]">
                                                  {formatSupport(
                                                    result.consequent_support
                                                  )}
                                                  %
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </section>
                                  );
                                })}

                              {/* {selectDesign === 2 &&
                                                                paginatedOrders.length > 0 && (
                                                                    <TableDesign
                                                                        paginatedOrders={paginatedOrders}
                                                                        order_details_id={data.order_details_id}
                                                                        isSingleOrderExclude={isSingleOrderExclude}
                                                                    />
                                                                )} */}

                              {paginatedOrders.length === 0 && (
                                <div className="flex flex-col items-center justify-center w-full py-10 text-center text-gray-500">
                                  <i className="fas fa-box-open text-4xl mb-2 text-gray-400"></i>
                                  <p className="text-lg font-semibold">
                                    No Record Found
                                  </p>
                                  <p className="text-sm text-gray-400 mt-1">
                                    We couldn't find any matching data.
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                          {totalPages > 1 && paginatedOrders.length > 0 && (
                            <div className="w-full pr-6 mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between">
                              <div className="text-sm text-gray-500 mb-3 sm:mb-0">
                                Showing{" "}
                                <span className="font-medium">
                                  {(currentPage - 1) * itemsPerPage + 1}
                                </span>{" "}
                                to
                                <span className="font-medium">
                                  {" "}
                                  {Math.min(
                                    currentPage * itemsPerPage,
                                    displayAnalysisResult.length
                                  )}
                                </span>{" "}
                                of
                                <span className="font-medium">
                                  {" "}
                                  {displayAnalysisResult.length}
                                </span>{" "}
                                results
                              </div>

                              <div className="inline-flex rounded-md shadow-sm">
                                <button
                                  disabled={currentPage === 1}
                                  onClick={() =>
                                    setCurrentPage((prev) => prev - 1)
                                  }
                                  className="relative inline-flex items-center px-3 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                                >
                                  Previous
                                </button>

                                {showLeftEllipsis && (
                                  <>
                                    <button
                                      onClick={() => setCurrentPage(1)}
                                      className="px-3 py-1 border rounded-md text-sm bg-white text-gray-700 hover:bg-gray-50"
                                    >
                                      1
                                    </button>
                                    <span className="px-2 py-1 text-sm text-gray-500">
                                      ...
                                    </span>
                                  </>
                                )}

                                {paginationRange.map((i) => (
                                  <button
                                    key={i}
                                    onClick={() => setCurrentPage(i)}
                                    className={`px-3 py-1 border rounded-md text-sm ${
                                      currentPage === i
                                        ? "bg-indigo-600 text-white"
                                        : "bg-white text-gray-700 hover:bg-gray-50"
                                    }`}
                                  >
                                    {i}
                                  </button>
                                ))}

                                {showRightEllipsis && (
                                  <>
                                    <span className="px-2 py-1 text-sm text-gray-500">
                                      ...
                                    </span>
                                    <button
                                      onClick={() => setCurrentPage(totalPages)}
                                      className="px-3 py-1 border rounded-md text-sm bg-white text-gray-700 hover:bg-gray-50"
                                    >
                                      {totalPages}
                                    </button>
                                  </>
                                )}

                                <button
                                  disabled={currentPage === totalPages}
                                  onClick={() =>
                                    setCurrentPage((prev) => prev + 1)
                                  }
                                  className="-ml-px relative inline-flex items-center px-3 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                                >
                                  {" "}
                                  Next{" "}
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    id="customer-segmentation-tab-content"
                    class={`fade-in ${
                      switchTab === 2 ? "overflow-y-auto" : "hidden"
                    }`}
                  >
                    <ProductBundles
                      productBundlesData={productsBundles}
                      totalTransactions={currentAnalysisData?.totalOrder ?? 0}
                      // customeValueData={customeValueData}
                    />
                  </div>

                  <div
                    id="customer-segmentation-tab-content"
                    class={`fade-in ${
                      switchTab === 3 ? "overflow-y-auto" : "hidden"
                    }`}
                  >
                    <FavoritePage
                      order_details_id={order_details_id}
                      analysis_details_id={currentAnalysisData._id}
                      switchTab={switchTab}
                      supportFilter={supportFilter}
                      sortBy={sortBy}
                      searchQueryForItemsets={searchQueryForItemsets}
                      selectedCombo={selectedCombo}
                      setCountItemSet={setCountItemSet}
                    />
                  </div>
                  <div
                    id="customer-segmentation-tab-content"
                    class={`fade-in ${
                      switchTab === 4 ? "overflow-y-auto" : "hidden"
                    }`}
                  >
                    <SkuReport 
                    analysis_details_id={currentAnalysisData._id}
                    switchTab={switchTab}
                    order_details_id={order_details_id}
                    isDefault={isDefault}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        {isModalOpen && order_details_id && (
          <CustomerPopupWithOrder
            isOpen={isModalOpen}
            onClose={() => setModalOpen(false)}
            title="Popup Title"
            order_details_id={order_details_id}
            sku={sku}
            isBoth={isBoth}
            isSingleExclude={isSingleOrderExclude}
            productList={productList}
          />
        )}
      </div>
    </>
  );
};

export default AnalysisResultData;
